// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"15":"c59c3700","395":"7c2e8347","453":"d855a71b","868":"5b3bbd11","906":"a6d2e083"}[chunkId] + ".chunk.js";
};